import axios from "axios";
import store from "../store";
import router from "../router";
import { createToaster } from '@meforma/vue-toaster';

class BaseService {

  getAxios(headerOptions) {

    let defaultHeader = {
      //"Content-type": "application/json",
      //'Accept': '*/*',
      //'Accept-Language': "en-US,en;q=0.5",
      //'Accept-Encoding': 'gzip, deflate, br, zstd',
      //'Connection': 'keep-alive',
      //"Content-type": 'application/x-www-form-urlencoded; charset=UTF-8',
      //"Access-Control-Allow-Origin": "*",
      //"current-userid": store.state.currentUserInfo.id,
      'Authorization': 'bearer ' + store.state.currentUserInfo.token,
    };

    if (!headerOptions) {
      headerOptions = defaultHeader;
    }
    else {
      headerOptions = { ...defaultHeader, ...headerOptions };
    }

    let $toast = createToaster({
      position: 'top-right',
      dismissible: true,
      pauseOnHover: true,
      useDefaultCss: true
    });

    let axios_api = axios.create({
      baseURL: store.getters.get_api_url,
      headers: headerOptions,
      responseType: 'json',
      //charset: 'utf-8',
      responseEncoding: 'utf8'
    });

    axios_api.interceptors.request.use((config) => {
      store.commit('loading', true);
      return config;
    }, (error) => {
      store.commit('loading', false);
      return Promise.reject(error);
    });

    axios_api.interceptors.response
      .use(function (response) {
        
        // if (response.data && response.data.isSuccess == false) {
        //   if (response.status == 401) {
        //     $toast.clear();
        //     $toast.error("نشست شما منقضی شده");
        //     router.replace({ path: '/signout' });
        //   }
        //   else if (response.data.code > 10010 && window.location.pathname != '/main') {
        //     $toast.error(response.data.message);
        //     router.replace({ path: '/main' });
        //   }
        // }

        store.commit('loading', false);

        // Do something with response data
        return Promise.resolve(response);

      },
        function (error) {
          if (error.message == "Network Error") {
            $toast.error('سرور در دسترس نمی باشد');
          }
          else if (error.response.status == 404) {
            $toast.error('آدرس سرویس درخواست شده یافت نشد');
          }
          if (error.response.status == 401) {
            $toast.clear();
            $toast.error("نشست شما منقضی شده");
            router.replace({ path: '/signout' });
          }
          
          store.commit('loading', false);

          // Do something with response error
          return Promise.reject(error);

        });

    return axios_api;
  }

  getBaseUrl() {
    return store.getters.get_api_url;
  }

  get(url, data) {
    return this.getAxios().get(url, {params : {...data}});
  }

  post(url, data) {
    return this.getAxios().post(url, data);
  }

  put(url, data) {
    return this.getAxios().put(url, data);
  }

  delete(url, data) {
    return this.getAxios().delete(url, data);
  }

  postFile(url, data) {
    return this.getAxios({
      'Content-Type': 'multipart/form-data',
      //"Content-type": 'application/x-www-form-urlencoded; charset=UTF-8',
      'content': "text/html; charset=utf-8"
    }).post(url, data);
  }

  getQueryStringOfObject(model) {

    if (!model) return '1=1';
    var strQuery = '';
    for (const [key, value] of Object.entries(model)) {
      if (!value || value == '') continue;
      strQuery += `${key}=${value}&`
    }

    return strQuery += '1=1';
  }

  getUnAuthorized(actionUrl) {
    return store.getters.get_api_url + actionUrl;
  }

}
export default new BaseService();


//const token = app.$cookies.get("token")
//if (token) {
//    $axios.defaults.headers.common.Authorization = "Token " + token
//}